import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Translate } from '../../../language';
import { searchAction } from '../../../actions/searchActions'
import ImageNameDescription from '../../../utils/components/ImageNameDescription/ImageNameDescription';
import ModalNotification from '../../../components/User/ModalNotification';
import ModalMessages from '../../../components/Rooms/ModalMessages';
import InputSearch from '../../../utils/components/InputSearch/InputSearch';
import useModal from '../../../utils/hooks/useModal';
import { MessagePendingIcon, NotificationsPendingIcon, ShopIcon, CuestionIcon, MenuIcon, LogoBorder } from '../../../assets/icons';
import circle from '../../../assets/img/circulogris.png';
import logoeco from '../../../assets/img/logoeco.png';
import NavbarMenu from '../NavbarMenu/NavbarMenu';
import socketLogic from "../../../sockets/sockets";
import './Navbar.css';
import style from './Navbar.module.css'
import { getNotificationsAddressee } from '../../../actions/notificationsActions';

import localStorage from '../../../utils/hooks/useLocalStorage';
import { getConversationsList } from '../../../actions/messagesActions';
import audioSound from "../../../assets/img/sound.mpeg"
const useAudio = url => {
    const audio_ = new Audio(url)
    audio_.volume = 0.2
    const [audio] = useState(audio_);
    const [playing, setPlaying] = useState(false);

    const toggle = () => setPlaying(!playing);

    useEffect(() => {
        playing ? audio.play() : audio.pause();
    },
        [playing]
    );

    useEffect(() => {
        audio.addEventListener('ended', () => setPlaying(false));
        return () => {
            audio.removeEventListener('ended', () => setPlaying(false));
        };
    }, []);

    return [playing, toggle];
};

const Navbar = ({
    islogin,
    isHome
}) => {
    const [playing, toggleSound] = useAudio(audioSound);
    const dispatch = useDispatch()
    const history = useHistory()
    const { isLoadingSearchList, searchList } = useSelector(state => state.users)
    const { userInfo } = useSelector(state => state.userInfo)
    const [notificacion, setNotification] = useState(0)
    const [message, setMessage] = useState(0)
    const [refNotification, isShowNotification, setIsShowNotification] = useModal(false)
    const [classAnimatedMsj, setClassAnimatedMsj] = useState("")
    const [refMessages, isShowMessages, setIsShowMessages] = useModal(false)
    const [refMenu, isShowMenu, setIsShowMenu] = useModal(false)
    const refAudio = useRef(null)

    const { listNotificationsAddresse } = useSelector(state => state.notifications)
    const { conversationsList } = useSelector(state => state.messages)
    const location = useLocation()
    const notificationEvent = ()=>{
        toggleSound()
           
        setTimeout(() => {
           
        }, 1000);
    }
    useEffect(() => {
        socketLogic.listenAllEvents("notification",notificationEvent)
     
        socketLogic.listenAllEvents("private-message", (res) => {
            setClassAnimatedMsj("animate__flash")
            console.log(location.pathname)
            if(!location.pathname.includes("Messages")){
                //toggleSound()
                refAudio.current.muted=false
                refAudio.current.play()
            }
           
            setTimeout(() => {
                setClassAnimatedMsj("")
            }, 1000);
        });
        return () => {
            console.log("return")
            socketLogic.removeListener("private-message")
            socketLogic.removeListener("notification",notificationEvent)
          }
       
          
     
    }, [location.pathname])
    
    useEffect(() => {
        
        

        if (!islogin) {
            dispatch(getNotificationsAddressee(false))
            dispatch(getConversationsList(false, false))
        }
      
      

    }, [])
    
    let navBarProfile = ""
    let navBarSearch = ""
    const [profilePicture, setProfilePicture] = useState(null)
    useEffect(() => {
        if (userInfo._id) {
            switch (localStorage().getItem("typeProfile")) {
                case "franchise":
                    setProfilePicture(userInfo.franchiseID.picture && userInfo.franchiseID.picture.url && userInfo.franchiseID.picture.url.origin)
                    break
                default:
                    setProfilePicture(userInfo.picture && userInfo.picture.url && userInfo.picture.url.origin)
                    break
            }

        }


        
    
    }, [userInfo])


    switch (localStorage().getItem("no typeProfile")) {
        case "franchise":
            navBarProfile = " navbar-component-ec"
            navBarSearch = " input-search-navbar-ec"
            break;

        default:
            break;
    }

    return (

        <div className={"navbar-component" + navBarProfile}>
              <audio muted ref={refAudio} autoPlay src={audioSound} preload="metadata" />
            {!isHome ?
                <>
                    {islogin ?
                        <div style={{ height: '40px' }}></div>
                        :
                        <img onClick={() => history.push('/Login')} src={logoeco} height={60}></img>
                    }
                </>
                :
                <>
                    <div className="content-icons-navbar">
                        <div onClick={() => history.push('/')} className={`icon-navbar first-icon-navbar ${style.logo_ecoideas}`}>
                            <div className="logo-full-navbar">
                                <img src={logoeco} height={50}></img>
                            </div>
                            <div className="logo-only-navbar">
                                <LogoBorder className="icon-50-navbar" />
                            </div>
                        </div>
                        <div className="spreader-bar-navbar"></div>
                        <div onClick={() => { 
                            if(localStorage().getItem("typeProfile") === "franchise" ){
                                history.push('/Franchise/' + localStorage().getItem("idUser") + '/') 
                            }else{
                                history.push('/Profile/' + localStorage().getItem("idUser") + '/') 
                            }
                       
                            
                            
                            }} className={`icon-navbar ${history.location.pathname.includes('Profile') ? 'active-icon-navbar' : ''}`}>
                            {profilePicture ? <img alt="img" className="navbar-img-icon" onError={(e) => e.target.src = circle} src={profilePicture}></img> :
                                <img alt="img" className="navbar-img-icon" src={circle}></img>}
                        </div>
                        <div className="spreader-bar-navbar"></div>
                        <div ref={refMessages} className="content-icon-navbar">
                            <div className={`icon-navbar ${isShowMessages && false ? 'active-icon-navbar' : ''} ${history.location.pathname.includes('Messages') && false ? 'active-icon-navbar' : ''}`}
                                onClick={() => { !history.location.pathname.includes('Messages') && setIsShowMessages(!isShowMessages) }}>
                                <MessagePendingIcon className="icon-normal-navbar" />
                                <div className={`icon-normal-navbar-counter animate__animated ${classAnimatedMsj}`}><div>{
                                    conversationsList.length
                                }</div></div>
                            </div>
                            {isShowMessages && <ModalMessages
                                isProfessionalUser={false}
                                isAdmin={false}
                                displayModal={isShowMessages}
                                setIsShowMessages={setIsShowMessages}
                                setNotificationMsg={() => { }}
                                setMessage={setMessage}
                            />}
                        </div>
                        <div className="spreader-bar-navbar"></div>
                        <div className={`icon-navbar`} onClick={() => { history.push('/MarketPlace') }} >
                            <ShopIcon className="icon-normal-navbar" />
                        </div>
                        <div className="spreader-bar-navbar"></div>
                        <div ref={refNotification} className="content-icon-navbar" >
                            <div className={`icon-navbar ${isShowNotification && false ? 'active-icon-navbar' : ''}`}
                                onClick={() => { setIsShowNotification(!isShowNotification) }}
                                style={{
                                    content: ""
                                }}
                            >
                                <NotificationsPendingIcon className="icon-normal-navbar" />
                                <div className="icon-normal-navbar-counter"><div>{
                                    listNotificationsAddresse.request.filter(notification => !notification.doYouSeeTheNotification).length +
                                    listNotificationsAddresse.othersNotifications.filter(notification => !notification.doYouSeeTheNotification).length +
                                    listNotificationsAddresse.paymentsNotifications.filter(notification => !notification.doYouSeeTheNotification).length +
                                    listNotificationsAddresse.pqrsNotifications.filter(notification => !notification.doYouSeeTheNotification).length
                                }</div></div>

                            </div>

                            {isShowNotification && <ModalNotification
                                isProfessionalUser={false}
                                displayModal={isShowNotification}
                                setIsShowNotification={setIsShowNotification}
                                setNotification={setNotification}
                            />}
                        </div>
                        <div className="spreader-bar-navbar"></div>
                    </div>
                    <InputSearch
                        placeholder={Translate('searchPalcheholder', 'es')}
                        classNameContent={"input-search-navbar"}
                        classNameInputSearch={navBarSearch}
                        searchData={(value) => dispatch(searchAction(value,"userAndFranchises"))}
                        isLoading={isLoadingSearchList}
                        renderData={searchList && searchList.userAndFranchises && (

                            <>
                                {
                                    searchList.userAndFranchises[0].users.map(user => {
                                        let data = user;
                                        if (user.warehouseID) {


                                         
                                            data.lastname = null

                                        }
                                        if (user.representativeID) {
                                            if (user.representativeID.state ===2) {

                                              
                                            }
                                        }
                                        return (
                                            <ImageNameDescription
                                                key={user._id}
                                                options={[]}
                                                onClick={() => {

                                                    history.push('/Profile/' + user._id)
                                                   
                                                }}
                                                description={null}
                                                srcImage={user.picture && user.picture.url ? user.picture.url.small : user.picture}
                                                firstName={user.name}
                                                secondName={user.lastname}
                                            />
                                        )
                                    }

                                    )
                                }
                                {
                                    searchList.userAndFranchises[0].franchises.map(franchise =>
                                        <ImageNameDescription
                                            key={franchise._id}
                                            options={[]}
                                            onClick={() => {
                                                history.push('/franchise/' + franchise.userID)
                                            }}
                                            description={null}
                                            srcImage={franchise.picture && franchise.picture.url ? franchise.picture.url.small : franchise.picture}
                                            firstName={franchise.socialReason}

                                        />

                                    )
                                }



                            </>
                        )}
                        xrenderData={searchList.users && searchList.users.map(user =>
                            <ImageNameDescription
                                key={user._id}
                                onClick={() => {
                                    history.push('/Profile/' + user._id)
                                }}
                                srcImage={user.picture && user.picture.url ? user.picture.url.small : user.picture}
                                firstName={user.name}
                                secondName={user.lastname}
                                description={null}
                            />)}
                    />
                </>
            }
            {isHome ?
                <>
                    <div className="content-menu-navbar" onClick={() => {
                        history.push("/HowEcoTienda")
                    }}>
                        <CuestionIcon style={{ cursor: 'pointer' }} className="icon-35-navbar" />
                    </div>
                    <div ref={refMenu} className="content-menu-navbar">
                        <MenuIcon style={{ cursor: 'pointer' }} className="icon-35-navbar" onClick={() =>
                            setIsShowMenu(!isShowMenu)
                        } />
                        {isShowMenu &&
                            <NavbarMenu userInfo={userInfo} setIsShowMenu={setIsShowMenu} isShowMenu={isShowMenu} />
                        }
                    </div>
                </>
                :
                <div className="text-color-green">
                    {Translate('aboutUs', 'es')}
                </div>
            }
        </div>
    )
}

export default Navbar
